const sliderSearchInit = () => {
    document.querySelectorAll(".bn-search-input[data-target-slider-id]").forEach((block) => {
        const input = block.querySelector(".bn-search-input__field");
        const form = block.querySelector(".bn-search-input__form");
        const slider = document.querySelector(`.bn-blog-posts .swiper[data-slider-id="${block.dataset.targetSliderId}"]`);

        if (!input || !slider) {
            return;
        }

        const wrapper = slider.querySelector(".swiper-wrapper");
        let scope = {};
        try {
            scope = JSON.parse(slider.dataset.searchScope || "{}");
        } catch (e) {
            scope = {};
        }

        const cache = new Map();
        let controller = null;
        let debounceTimer = null;

        const render = (html) => {
            if (slider.swiper) {
                slider.swiper.destroy(true, true);
            }
            wrapper.innerHTML = html;
            if (slider.bnReinit) {
                slider.bnReinit();
            }
        };

        const search = (phrase) => {
            if (cache.has(phrase)) {
                render(cache.get(phrase));
                return;
            }

            if (controller) {
                controller.abort();
            }
            controller = new AbortController();

            const params = new URLSearchParams({ action: "bn_blog_posts_search", s: phrase });
            ["source", "category", "tags", "author", "include", "per_page", "random", "read_more"].forEach((key) => {
                if (scope[key]) {
                    params.set(key, scope[key]);
                }
            });

            slider.classList.add("is-searching");
            fetch(`${block.dataset.ajaxUrl}?${params.toString()}`, { signal: controller.signal })
                .then((response) => response.json())
                .then((result) => {
                    if (result.success && result.data.html) {
                        cache.set(phrase, result.data.html);
                        render(result.data.html);
                    }
                    slider.classList.remove("is-searching");
                })
                .catch((error) => {
                    if (error.name !== "AbortError") {
                        slider.classList.remove("is-searching");
                    }
                });
        };

        input.addEventListener("input", () => {
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(() => search(input.value.trim()), 350);
        });

        if (form) {
            form.addEventListener("submit", (event) => {
                event.preventDefault();
                clearTimeout(debounceTimer);
                search(input.value.trim());
            });
        }
    });
};

document.addEventListener("DOMContentLoaded", function () {
    if (document.body && !document.body.classList.contains("block-editor-page") && !document.body.classList.contains("block-editor-iframe__body")) {
        sliderSearchInit();
    }
});
